<template>
	<div class="poi-searching">
		<div class="dot" v-for="(o, i) in Array(3)" :key="i" :class="`dot-${i}`"></div>
	</div>
</template>

<script>
export default {
	name: 'poiSearching'
};
</script>

<style scoped lang="scss">
	.poi-searching {
		width: 100%;
		height: auto;
		padding: 12px 0;
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		@keyframes flash {
			from {
				opacity: 0.3;
			}
			to {
				opacity: 1;
			}
		}

		.dot {
			width: 6px;
			height: 6px;
			background: #999999;
			border-radius: 50%;
			margin: 0 5px;
			animation: flash 1s linear infinite;

			&-0 {
				animation-delay: .3s;
			}

			&-1 {
				animation-delay: .6s;
			}

			&-2 {
				animation-delay: .9s;
			}
		}
	}
</style>
